import type { Dict } from '../types';
import { en } from './en';

export const te: Dict = en;
